import { useContext, useState, useEffect } from "react";
import { Box, Stack } from "@mui/material";

import config 					from "../../../common/Config";
import useFetch 				from "../../../api/api";
import useAuth 					from "../../../hooks/useAuth";
import CompanyContext 			from "../context";

import LoadingCard 				from "../../Dashboard/components/LoadingCard";
import DiscountedCashFlow 		from "../../../components/Valuation/DiscountedCashFlow";
import RelativeValuation 		from "../../../components/Valuation/RelativeValuation";
import DividendDiscountModel 	from "../../../components/Valuation/DividendDiscountModel";
import RestrictedAccess 		from "../../../components/RestrictedAccess";

const TabValuation = ({props}) => {

	const { company, indicators, selectedStock, stocks, exchangeRate } = useContext(CompanyContext);
	const { auth }									= useAuth()
	const privateFetch 								= useFetch()

	const [isLoading, setIsLoading] 				= useState(true);
	const [stockPrice, setStockPrice]				= useState()
	const [inflation, setInflation]					= useState()
	const [yearlyDividends, setYearlyDividends]		= useState()


	useEffect(() => {
		setIsLoading(true)
		if (company && indicators && auth.userId) loadData()
	}, [company, indicators])

	const loadData = async () => {
		// Busca dados de inflação
		await privateFetch(config.apiUrl +"/api/indicators/"+ (company.country == 'BR' ? 'BR' : 'US'))
		.then((data) => data.json())
		.then((data) => {
			if (data[0].inflation && data[1].inflation) {
				const currentInflation = (data[0].inflation / data[1].inflation) - 1
				setInflation(parseFloat(currentInflation * 100).toFixed(2));
			}
		})

		// Calcula os dividendos e agrupa eles anualmente
		let currentDividends = []	
		const stockDividends = stocks.find(s => s.ticker === selectedStock)?.dividends || []

		for (let d of stockDividends) {
			let index = currentDividends.findIndex(yd => yd.date === new Date(d.date).getFullYear())

			if (index >= 0) {
				if (currentDividends[index]) {
					currentDividends[index].dividend 		+= parseFloat(d.value)
					currentDividends[index].adjustedDividend	+= parseFloat(d.adjustedValue)
				}
				else {
					currentDividends[index].dividend 		= parseFloat(d.value)
					currentDividends[index].adjustedDividend	= parseFloat(d.adjustedValue)
				}
			}
			else {
				if (new Date(d.date).getFullYear() !== 1969 && new Date(d.date).getFullYear() <= new Date().getFullYear() ) {
					currentDividends.push({
						date 				: new Date(d.date).getFullYear(),
						dividend			: parseFloat(d.value),
						adjustedDividend	: parseFloat(d.adjustedValue)
					})
				}
			}
		}

		// Arredonda os valores
		currentDividends.map(yd => {
			Object.keys(yd).map(key => {
				switch(key) {
					case 'dividend' 		: yd[key] = parseFloat(yd[key]).toFixed(2); break;
					case 'adjustedDividend'	: yd[key] = parseFloat(yd[key]).toFixed(4); break;
				}
			})
		})

		setStockPrice(indicators.find(i => i.id == 'price')?.value)
		setYearlyDividends(currentDividends.sort((a,b) => a.date - b.date))
		setIsLoading(false)
	}	

	if (!auth.userId) {
		return (
			<Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '78vh'}}>
				<RestrictedAccess />
			</Box>	
		)
	}
	
	if (isLoading) {
		return <LoadingCard />
	}	

	return (
		<Stack p={2} direction="column" spacing={2} >
			<Stack direction={{xs: "column", md: "row"}} spacing={2} width={'100%'}>
				<RelativeValuation selectedStock={selectedStock} siblingStocks={stocks.map(s => s.ticker)} company={company} indicators={indicators}/>
			</Stack>
			
			{/* <Stack direction={{xs: "column", md: "row"}} spacing={2} width={'100%'}>
				<Box sx={{ flex: 1, display: 'flex' }}><DiscountedCashFlow company={company} inflation={inflation} stockPrice={stockPrice} exchangeRate={exchangeRate}/></Box>
				<Box sx={{ flex: 1, display: 'flex' }}><DividendDiscountModel company={company} inflation={inflation} stockPrice={stockPrice} indicators={indicators} dividends={yearlyDividends} /></Box>
			</Stack> */}
		</Stack>
	);
};

export default TabValuation;
